import{Z as o,d as s}from"./p-DW5uD8S_.js";const t=o;const p=s;export{t as ZprTooltip,p as defineCustomElement};
//# sourceMappingURL=zpr-tooltip.js.map